import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DialogComponent,
  FilesUploader,
  Spinner,
} from '../../../../../Components';
import { ButtonBase, DialogActions } from '@material-ui/core';
import {
  AddVendorClientTrackingDocuments,
  DeleteVendorClientTrackingDocument,
  GetVendorClientTrackingDocuments,
} from '../../../../../Services';
import { showError, showSuccess } from '../../../../../Helper';

function ClientTrackingAddReceiptDialog({
  isOpen,
  onClose,
  activeItem,
  parentTranslationPath,
}) {
  const { t: translate } = useTranslation(parentTranslationPath);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleFilesUploaded = (files) => {
    setUploadedFiles(files);
  };

  const handleConfirm = async () => {
    onClose();
  };

  const GetVendorClientTrackingById = async () => {
    setIsLoading(true);
    const res = await GetVendorClientTrackingDocuments(
      activeItem?.vendorClientTrackingId,
      1,
      999999
    );
    if (res) {
      const filesBuffer =
        res?.result?.map((item) => ({
          id: item.vendorClientTrackingDocumentId,
          fileName: item.fileName,
          uuid: item.fileId || item.uuid || null,
          url: item.fileUrl || item.url || null,
          vendorClientTrackingDocumentId:
            item.vendorClientTrackingDocumentId || null,
        })) || [];
      setUploadedFiles(filesBuffer);
    }
    setIsLoading(false);
  };

  const DeleteVendorClientTrackingDocumentByDocumentId = async (file) => {
    setIsLoading(true);
    if (file.vendorClientTrackingDocumentId) {
      const res = await DeleteVendorClientTrackingDocument(
        file.vendorClientTrackingDocumentId
      );
      if (res) {
        showSuccess(translate('document-deleted-successfully'));
        GetVendorClientTrackingById();
      } else {
        setIsLoading(false);
        showError(translate('document-deletion-failed-error'));
      }
    }
  };

  const AddNewVendorClientTrackingDocuments = async (files) => {
    setIsLoading(true);

    const processedFiles = files || [];
    const validFiles = processedFiles.filter((element) => element.uuid);

    const documentsBuffer = validFiles.map((element) => ({
      fileName: element.fileName,
      fileId: element.uuid,
    }));

    if (documentsBuffer.length > 0) {
      const body = {
        vendorClientTrackingId: activeItem?.vendorClientTrackingId,
        documents: documentsBuffer,
      };

      const res = await AddVendorClientTrackingDocuments(body);
      if (res) {
        setTimeout(() => {
          GetVendorClientTrackingById();
        }, 500);
        showSuccess(translate('documents-added-successfully'));
      } else {
        setIsLoading(false);
        showError(translate('documents-addition-failed-error'));
      }
    }
  };

  useEffect(() => {
    if (activeItem) {
      GetVendorClientTrackingById();
    }
  }, [activeItem]);

  return (
    <>
      <DialogComponent
        isOpen={isOpen}
        titleText='Add Receipt'
        maxWidth={'md'}
        dialogContent={
          <>
            <Spinner isAbsolute={true} isActive={isLoading || isUploading} />
            <div>
              <div>
                <FilesUploader
                  accept='application/pdf,image/jpeg,image/png'
                  multiple={true}
                  initUploadedFiles={uploadedFiles}
                  uploadedChanged={handleFilesUploaded}
                  setIsUploading={setIsUploading}
                  uploadingHandler={AddNewVendorClientTrackingDocuments}
                  onItemRemoved={DeleteVendorClientTrackingDocumentByDocumentId}
                />
              </div>
              <div>
                <DialogActions>
                  <ButtonBase
                    disabled={false}
                    onClick={handleConfirm}
                    className='MuiButtonBase-root btns theme-solid'
                  >
                    {translate('confirm')}
                  </ButtonBase>
                </DialogActions>
              </div>
            </div>
          </>
        }
        parentTranslationPath={parentTranslationPath}
      />
    </>
  );
}

export default ClientTrackingAddReceiptDialog;
